import Image from "next/image"
import React, { FC } from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Title = styled.div`
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  margin-top: 16px;
  @media (max-width: 1023px) {
    font-size: 16px;
    margin-top: 14px;
  }
`
const Description = styled.div`
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffffcc;
  margin-top: 8px;
  white-space: pre-wrap;

  @media (max-width: 1023px) {
    font-size: 14px;
    white-space: normal;
  }
`

const ImageWrapper = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  object-fit: "contain";
  @media (max-width: 1023px) {
    width: 32px;
    height: 32px;
  }
`

export const MissionVisionContent: FC<{
  iconSrc: string
  title: string
  description: string
}> = ({ iconSrc, title, description }) => {
  return (
    <Wrapper>
      <ImageWrapper>
        <Image src={iconSrc} alt={title} width={40} height={40} />
      </ImageWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Wrapper>
  )
}
